import { Component, OnInit } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { NgbCalendar, NgbDateStruct, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { VisorComentariosAnulacionComponent } from './visor-comentarios-anulacion/visor-comentarios-anulacion.component';
import { AerovalesService } from '@despacho/aerovales.service';
import { EstadoAerovale } from '@shared/enums/estadoAerovale';
import { NgxSpinnerService } from 'ngx-spinner';
import { AerovaleDetalleComponent } from '@despacho/aerovale-detalle/aerovale-detalle.component';
import { ComprobanteService } from '@facturacion/comprobante.service';
import { VisorComprobanteComponent } from '@shared/visor-comprobante/visor-comprobante.component';
import { CierreTurnoService } from '@cierreTurno/cierre-turno.service';
import { Aeroplanta } from '@shared/models/cierreTurno/Aeroplanta';
import { AerovaleCompletoReporteTrazabilidad } from '@shared/models/facturacion/AerovaleCompletoReporteTrazabilidad';
import { ReportesService } from '@reportes/reportes.service';
import { ExportExcelServiceService } from '@shared/exportar-excel/export-excel-service.service';
import { MessageService } from '@shell/message.service';
import { AuthService } from '@authentication/auth.service';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-reporte-anulacion-aerovales',
  templateUrl: './reporte-anulacion-aerovales.component.html',
  styleUrls: ['./reporte-anulacion-aerovales.component.scss']
})
export class ReporteAnulacionAerovalesComponent implements OnInit {

  modelDesde: NgbDateStruct;
  modelHasta: NgbDateStruct;
  cargandoComprobante: boolean = false;
  fechaDesde: Date;
  fechaHasta: Date;
  aeroplantas: Aeroplanta[];
  cargandoAeroplantas: boolean;
  EstadoAerovale = EstadoAerovale;
  cargandoAerovales: boolean;
  busquedaFormControl = new UntypedFormControl();
  aerovales: AerovaleCompletoReporteTrazabilidad[] = [];
  aerovalesSinFiltrar: AerovaleCompletoReporteTrazabilidad[];
  aeroplantasAFiltrar = ['TDL', 'JNI', 'ENO', 'DTO', 'CUT', 'SCL', 'SCE'];
  encabezadosExcel: string[];
  TipoUsuario = TipoUsuario;

  constructor(private calendar: NgbCalendar, private modalService: NgbModal, private aerovaleService: AerovalesService,
    private spinner: NgxSpinnerService, private comprobanteService: ComprobanteService,
    private cierreTurnoService: CierreTurnoService, private reportesService: ReportesService,
    private excelService: ExportExcelServiceService, private messageService: MessageService,
    public authService: AuthService, private datePipe: DatePipe) { }

  ngOnInit() {
    this.modelDesde = this.calendar.getToday();
    this.modelHasta = this.calendar.getToday();
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.obtenerAeroplantas();
  }

  obtenerAeroplantas() {
    this.cargandoAerovales = true;
    this.spinner.show('spinnerLista');
    this.cierreTurnoService.getAeroplantas3()
      .subscribe(a => {
        this.aeroplantas = a.sort((a, b) => { { if (a.nombre > b.nombre) { return 1 } else { return -1 } } });
        this.aeroplantas = this.aeroplantas.filter(a => !this.aeroplantasAFiltrar.includes(a.codigo));
        this.aeroplantas.forEach(aeroplanta => aeroplanta.seleccionada = false);
        this.obtenerAerovales();
      }, () => {
        this.cargandoAerovales = false;
        this.messageService.showErrorMessage("Error al cargar las aeroplantas");
      });
  }

  obtenerAerovales() {
    this.reportesService.obtenerAerovalesCompletosReporteTrazabilidad(this.getFechaDesde(), this.getFechaHasta())
      .subscribe(response => {
        this.aerovalesSinFiltrar = response.aerovales;
        this.encabezadosExcel = response.encabezadosExcel;
        this.filtrarAerovalesPorAeroplanta();
      }, () => {
        this.cargandoAerovales = false;
        this.messageService.showErrorMessage("Error al cargar los aerovales");
      });
  }


  filtrarAerovalesPorFecha() {
    this.spinner.show('spinnerLista');
    this.cargandoAerovales = true
    this.fechaDesde = new Date(this.modelDesde.year, this.modelDesde.month - 1, this.modelDesde.day);
    this.fechaHasta = new Date(this.modelHasta.year, this.modelHasta.month - 1, this.modelHasta.day);
    this.reportesService.obtenerAerovalesCompletosReporteTrazabilidad(this.getFechaDesde(), this.getFechaHasta()).subscribe(response => {
      this.aerovalesSinFiltrar = response.aerovales;
      this.filtrarAerovalesPorAeroplanta();
    }, () => {
      this.cargandoAerovales = false;
      this.fechaDesde > this.fechaHasta ? this.messageService.showErrorMessage("La fecha inicial debe ser anterior a la fecha final")
        : this.messageService.showErrorMessage("Error al cargar los aerovales");
    });
  }

  filtrarAerovalesPorAeroplanta() {
    this.aeroplantasAFiltrar = this.aeroplantas.filter(a => a.seleccionada).map(a => a.codigo);
    if (this.aeroplantasAFiltrar.length > 0) {
      this.aerovales = this.aerovalesSinFiltrar.filter(a => this.aeroplantasAFiltrar.includes(a.aeroplanta.codigoAeroplanta));
    } else {
      this.aerovales = this.aerovalesSinFiltrar;
    }
    this.cargandoAerovales = false;
    this.spinner.hide('spinnerLista');
  }

  filtrarAerovales() {
    const busqueda = this.busquedaFormControl.value ? this.busquedaFormControl.value : '';
    this.aerovales = this.aerovalesSinFiltrar.filter(a => {
      if (!a.numeroAerovaleReemplazo) a.numeroAerovaleReemplazo = "";
      return a.numeroAerovale.includes(busqueda) || a.numeroAerovaleReemplazo.includes(busqueda);
    });
    this.cargandoAerovales = false;
    this.spinner.hide('spinnerLista');
  }

  mostrarComentario(comentario) {
    const modalRef = this.modalService.open(VisorComentariosAnulacionComponent, { centered: true, backdrop: "static" })
    modalRef.componentInstance.comentario = comentario;
  }

  mostrarAerovale(id) {
    this.cargandoComprobante = true;
    this.aerovaleService.getAerovalePorIdyTipo(id)
      .subscribe(aerovaleDetalle => {
        const modalRef = this.modalService.open(AerovaleDetalleComponent, { centered: true, backdrop: "static", size: 'lg' });
        modalRef.componentInstance.aerovaleDetalle = aerovaleDetalle;
        this.cargandoComprobante = false;
      }, () => {
        this.cargandoAerovales = false;
        this.messageService.showErrorMessage("Error al cargar el aerovale");
      });
  }

  mostrarComprobante(id: string) {
    this.comprobanteService.obtenerComprobantePorId(id)
      .subscribe(comprobante => {
        const modalRef = this.modalService.open(VisorComprobanteComponent, { centered: true, backdrop: "static", size: 'lg' });
        modalRef.componentInstance.facturaObtenida = comprobante;
        this.cargandoComprobante = false;
      })
  }

  obtenerComprobanteId(id) {
    this.cargandoComprobante = true;
    this.comprobanteService.obtenerComprobanteIdSegunAerovale(id)
      .subscribe(importeFactura => {
        this.mostrarComprobante(importeFactura.facturaId);
      }, () => {
        this.cargandoAerovales = false;
        this.messageService.showErrorMessage("Error al cargar el comprobante");
      });
  }

  mostrarNota(id) {
    this.cargandoComprobante = true;
    this.comprobanteService.obtenerNotaPorIdAerovale(id)
      .subscribe(nota => {
        const modalRef = this.modalService.open(VisorComprobanteComponent, { centered: true, backdrop: "static", size: 'lg' });
        modalRef.componentInstance.facturaObtenida = nota;
        this.spinner.hide('spinnerLista');
        this.cargandoComprobante = false;
      }, () => {
        this.cargandoAerovales = false;
        this.messageService.showErrorMessage("Error al cargar el comprobante");
      });
  }

  puedeVerFactura(a) {
    if(this.authService.hasRole(TipoUsuario.RESPRODUCTO, TipoUsuario.JEFEDEAEROPLANTA) && a.condicionDeVenta == "Cuenta Corriente") {
      return false
    } else return true;
  }

  toggleDatepicker(e: any) {
    e.toggle();
  }

  getFechaDesde() {
    return this.formatDate(this.fechaDesde.getFullYear(), this.fechaDesde.getMonth() + 1, this.fechaDesde.getDate(), 0, 0, 0);
  }

  getFechaHasta() {
    return this.formatDate(this.fechaHasta.getFullYear(), this.fechaHasta.getMonth() + 1, this.fechaHasta.getDate(), 23, 59, 59);
  }

  descargarExcel() {
    const jsonExcel = this.aerovales.map(aerovale => {
      const jsonObject = {};
      this.encabezadosExcel.forEach((key, index) => {
        jsonObject[key] = aerovale.filaExcel[index]
      });
      return jsonObject;
    });
    this.excelService.exportAsExcelFile(jsonExcel, "Reporte de trazabilidad");
  }

  formatDate(year, month, day, hour, minute, seconds): string {
    return year + '-' + month.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + '-' + day.toLocaleString(undefined, { minimumIntegerDigits: 2 })
      + 'T' + hour.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + minute.toLocaleString(undefined, { minimumIntegerDigits: 2 }) + ':' + seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
  }

  fechaValida(fecha) {
    if(fecha.startsWith('0001-01-01')){
      return "--";
    } else return this.datePipe.transform(fecha, "dd'/'MM'/'y hh:mm a");
  }

  getEstado(a) {
    return EstadoAerovale[a];
  }

  getOperador(o) {
    const operador = JSON.parse(o);
    return operador.NombreCompleto
  }

  get busqueda() {
    return this.busquedaFormControl;
  }
}
